import Permission from 'src/models/access-control/Permission'
import Role from 'src/models/access-control/Role'
import RolePermissionRecordRestrictions from 'src/models/access-control/RolePermissionRecordRestriction'
import Model, { encoders, ID, JsonObject, MODEL_LEVEL, TYPE_NAME_TO_MODEL_MAP } from 'src/models/model'

export const CONDITIONS_REQUIREMENTS_TYPES = {
  FILTER_REPORT_CATEGORY_IDS: 'filter_report_category_ids',
  EXCLUDE_REPORT_CATEGORY_IDS: 'exclude_report_category_ids'
}
CONDITIONS_REQUIREMENTS_TYPES.ALL = _.values(CONDITIONS_REQUIREMENTS_TYPES)

export default class RolePermission extends Model {
  static name = 'RolePermission'

  static deletable = true

  static versioned = true

  static paginate = true

  static level = MODEL_LEVEL.CIRCUIT

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Security]
  static manageAction = 'ManageCircuitRoles'

  static define () {
    this.fields = {
      id: {
        type: ID,
        sortable: true,
        required: true
      },

      role: {
        type: Role,
        reference: true,
        encode: encoders.hasOne,
        output: true
      },
      permission: {
        type: Permission,
        reference: true,
        default: null,
        output: true
      },
      rolePermissionRecordRestrictions: {
        type: [RolePermissionRecordRestrictions],
        acceptsNestedAttributes: true,
        allowDestroy: true,
        default: () => ([]),
        excludeFromDefault: true
      },
      action: {
        type: String,
        default: null
      },
      conditionsRequirements: {
        type: JsonObject,
        mergeDefault: true,
        default: () => ({ excludeRestrictableTypes: [] })
      },
      restrictsRecords: {
        type: Boolean,
        default: false,
        output: true,
        excludeFromDefault: true
      },
      restrictableModelNames: {
        type: [String],
        default: () => ([]),
        output: true,
        excludeFromDefault: true
      }
    }
  }

  get category () {
    return this.permission?.category
  }

  get label () {
    return this.permission?.label
  }

  get description () {
    return this.permission?.description
  }

  get dependsOnPermission () {
    return this.permission?.dependsOnPermission
  }

  get permitsEmployeeUsers () {
    return this.permission?.permitsEmployeeUsers || false
  }

  get permitsAdminUsers () {
    return this.permission?.permitsAdminUsers || false
  }

  get restrictableModels () {
    return _.compact(_.map(this.restrictableModelNames, modelName => TYPE_NAME_TO_MODEL_MAP[modelName]))
  }

  get restrictedRecordsByModelName () {
    return _.groupBy(this.rolePermissionRecordRestrictions.data, 'restrictableType')
  }

  get restrictedRecordCountByModelName () {
    return _.mapValues(this.restrictedRecordsByModelName, records => records.length)
  }

  excludesRestrictedRecords (ofType) {
    return _.includes(this.conditionsRequirements.excludeRestrictableTypes, ofType)
  }
}
